/* Rquiere de errors.js */

var axiosSystem = {
	methods:{
		axiosSystem(method, url, responseFunction, data = null, headers = null) {
			headers = (headers == null) ? this.getHeaders : headers
			switch(method) {
				case 'DELETE':
					this.axiosDelete(url, responseFunction, headers)
					break;
				case 'GET':
					this.axiosGet(url, responseFunction, headers)
					break;
				case 'POST':
					this.axiosPost(url, data, responseFunction, headers)
					break;
				case 'PUT':
					this.axiosPut(url, data, responseFunction, headers)
					break;
				default:
					this.axiosError('No está determinado el metodo de comunicación (DELETE, GET, POST, PUT)')
					break;
			}
		},
		axiosDelete(url, responseFunction, headers) {
			this.axios.delete(url, { headers: headers })
					.then(response => { this.axiosResponse(responseFunction, response) })
					.catch(error  => { this.axiosError(error) })
		},
		axiosGet(url, responseFunction, headers) {
			this.axios.get(url, { headers: headers })
					.then(response => { this.axiosResponse(responseFunction, response) })
					.catch(error  => { this.axiosError(error) })
		},
		axiosPost(url, data, responseFunction, headers) {
			this.axios.post(url, data, { headers: headers })
					.then(response => { this.axiosResponse(responseFunction, response) })
					.catch(error  => { this.axiosError(error) })
		},
		axiosPut(url, data, responseFunction, headers) {
			this.axios.put(url, data, { headers: headers })
					.then(response => { this.axiosResponse(responseFunction, response) })
					.catch(error  => { this.axiosError(error) })
		},
		axiosResponse(responseFunction, response) {
			try {
				this[responseFunction](response)
			} catch (error) {
				this.axiosError(error)
			}
		},
		axiosError(error) {
			alert(error)
			console.log(error)
		}
	},
};

export default axiosSystem;